export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9579.f289c234.jpg";